// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import React, { useEffect } from 'react';
import { app, dialog } from "@microsoft/teams-js";
import { useTranslation } from 'react-i18next';
import { makeStyles, Text, tokens } from "@fluentui/react-components";

const useStyles = makeStyles({
    errorMessage: {
        display: 'flex',
        flexGrow: 1,
        alignItems: 'center',
        justifyContent: 'center',
        color: tokens.colorPaletteRedForeground3
    }
});



const NotFound = () => {

    const { t } = useTranslation();
    const styles = useStyles();
    useEffect(() => {
        app.notifySuccess();
        if (app.getFrameContext() && app.getFrameContext() !== 'settings') {
            dialog.update.resize({
                height: 100,
                width: 300
            });
        }
    }, []);


    return (
        <Text className={styles.errorMessage}>
            {t("PageNotFound")}
        </Text>
    );
};

export default NotFound;